import React from 'react';
import { FormSection, Field } from 'redux-form';
import _ from 'lodash';

import { isNumber, isMoneyNumber } from 'src/utils/CustomValidators';
import { numberWithComma } from 'src/utils/Utils';
import EditableTextField from './EditableTextField';

class MonthlySummaryAccidentInsurance extends React.Component {
  constructor(props) {
    super(props);
    const { monthlySummary } = props;
    this.state = { ...monthlySummary };
  }

  componentWillMount() {
    this.calculation({ ...this.state });
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  calculation(params) {
    const calcValues = {
      totalAccidentInsuranceEmployeeCount: this.calcTotalAccidentInsuranceCount(params),
      totalAccidentInsuranceEmployeePay: this.calcTotalAccidentInsurancePay(params),
      totalEmploymentInsuranceEmployeeCount: this.calcTotalEmploymentInsuranceCount(params),
      totalEmploymentInsuranceEmployeePay: this.calcTotalEmploymentInsurancePay(params)
    };

    this.setState({
      ...params,
      ...calcValues
    });

    return { ...params, ...calcValues };
  }

  // 労災保険及び一般拠出金の合計人数
  calcTotalAccidentInsuranceCount(params) {
    return this.sum([
      params.accidentInsuranceEmployeeCommonCount,
      params.accidentInsuranceEmployeeTreatedCount,
      params.accidentInsuranceEmployeeTemporaryCount
    ]);
  }

  // 労災保険及び一般拠出金の合計賃金
  calcTotalAccidentInsurancePay(params) {
    return this.sum([
      params.accidentInsuranceEmployeeCommonPay,
      params.accidentInsuranceEmployeeTreatedPay,
      params.accidentInsuranceEmployeeTemporaryPay
    ]);
  }

  // 雇用保険の合計人数
  calcTotalEmploymentInsuranceCount(params) {
    return this.sum([params.employmentInsuranceEmployeeCommonCount, params.employmentInsuranceEmployeeTreatedCount]);
  }

  // 雇用保険の合計賃金
  calcTotalEmploymentInsurancePay(params) {
    return this.sum([params.employmentInsuranceEmployeeCommonPay, params.employmentInsuranceEmployeeTreatedPay]);
  }

  sum(list) {
    // すべてが空の場合は空文字を返す
    if (_.every(list, o => !_.isNumber(o))) return '';

    _.filter(list, o => {
      _.toInteger(o);
    });

    return _.reduce(list, (sum, n) => sum + n, 0);
  }

  calcYearlySummary(changedParams) {
    const params = {
      ...this.state,
      ...changedParams
    };

    this.props.calcYearlySummary(this.calculation(params));
  }

  // 労災保険常用労働者の人数変更イベント
  onChangeAccidentInsuranceEmployeeCommonCount(value) {
    this.calcYearlySummary({ accidentInsuranceEmployeeCommonCount: _.toInteger(value) });
  }

  // 労災保険常用労働者の賃金変更イベント
  onChangeAccidentInsuranceEmployeeCommonPay(value) {
    this.calcYearlySummary({ accidentInsuranceEmployeeCommonPay: _.toInteger(value) });
  }

  // 労災保険役員兼従業員の人数変更イベント
  onChangeAccidentInsuranceEmployeeTreatedCount(value) {
    this.calcYearlySummary({ accidentInsuranceEmployeeTreatedCount: _.toInteger(value) });
  }

  // 労災保険役員兼従業員の賃金変更イベント
  onChangeAccidentInsuranceEmployeeTreatedPay(value) {
    this.calcYearlySummary({ accidentInsuranceEmployeeTreatedPay: _.toInteger(value) });
  }

  // 労災保険臨時労働者の人数変更イベント
  onChangeAccidentInsuranceEmployeeTemporaryCount(value) {
    this.calcYearlySummary({ accidentInsuranceEmployeeTemporaryCount: _.toInteger(value) });
  }

  // 労災保険臨時労働者の賃金変更イベント
  onChangeAccidentInsuranceEmployeeTemporaryPay(value) {
    this.calcYearlySummary({ accidentInsuranceEmployeeTemporaryPay: _.toInteger(value) });
  }

  render() {
    const { actionMode, monthlySummary } = this.props;
    return (
      <FormSection name={`monthlySummaries.${monthlySummary.id}`}>
        <tr key={`monthly_summary_${monthlySummary.id}`}>
          <th>
            {monthlySummary.paymentType === 'pay' && monthlySummary.displayMonthlySummaryDate}
            {monthlySummary.paymentType === 'bonus' && `賞与 ${monthlySummary.displayMonthlySummaryDate}`}
          </th>
          <td>
            {monthlySummary.paymentType === 'pay' && (
              <Field
                name="accidentInsuranceEmployeeCommonCount"
                showValue={monthlySummary.accidentInsuranceEmployeeCommonCount}
                showMode={actionMode}
                inputWidth={70}
                validate={[isNumber]}
                component={EditableTextField}
                onChange={e => {
                  this.onChangeAccidentInsuranceEmployeeCommonCount(e.target.value);
                }}
                onBlur={e => {
                  this.onChangeAccidentInsuranceEmployeeCommonCount(e.target.value);
                }}
              />
            )}
          </td>
          <td>
            <Field
              name="accidentInsuranceEmployeeCommonPay"
              showValue={monthlySummary.accidentInsuranceEmployeeCommonPay}
              showMode={actionMode}
              inputWidth={70}
              validate={[isMoneyNumber]}
              component={EditableTextField}
              onChange={e => {
                this.onChangeAccidentInsuranceEmployeeCommonPay(e.target.value);
              }}
              onBlur={e => {
                this.onChangeAccidentInsuranceEmployeeCommonPay(e.target.value);
              }}
            />
          </td>
          <td>
            {monthlySummary.paymentType === 'pay' && (
              <Field
                name="accidentInsuranceEmployeeTreatedCount"
                showValue={monthlySummary.accidentInsuranceEmployeeTreatedCount}
                showMode={actionMode}
                inputWidth={70}
                validate={[isNumber]}
                component={EditableTextField}
                onChange={e => {
                  this.onChangeAccidentInsuranceEmployeeTreatedCount(e.target.value);
                }}
                onBlur={e => {
                  this.onChangeAccidentInsuranceEmployeeTreatedCount(e.target.value);
                }}
              />
            )}
          </td>
          <td>
            <Field
              name="accidentInsuranceEmployeeTreatedPay"
              showValue={monthlySummary.accidentInsuranceEmployeeTreatedPay}
              showMode={actionMode}
              inputWidth={70}
              validate={[isMoneyNumber]}
              component={EditableTextField}
              onChange={e => {
                this.onChangeAccidentInsuranceEmployeeTreatedPay(e.target.value);
              }}
              onBlur={e => {
                this.onChangeAccidentInsuranceEmployeeTreatedPay(e.target.value);
              }}
            />
          </td>
          <td>
            {monthlySummary.paymentType === 'pay' && (
              <Field
                name="accidentInsuranceEmployeeTemporaryCount"
                showValue={monthlySummary.accidentInsuranceEmployeeTemporaryCount}
                showMode={actionMode}
                inputWidth={70}
                validate={[isNumber]}
                component={EditableTextField}
                onChange={e => {
                  this.onChangeAccidentInsuranceEmployeeTemporaryCount(e.target.value);
                }}
                onBlur={e => {
                  this.onChangeAccidentInsuranceEmployeeTemporaryCount(e.target.value);
                }}
              />
            )}
          </td>
          <td>
            <Field
              name="accidentInsuranceEmployeeTemporaryPay"
              showValue={monthlySummary.accidentInsuranceEmployeeTemporaryPay}
              showMode={actionMode}
              inputWidth={70}
              validate={[isMoneyNumber]}
              component={EditableTextField}
              onChange={e => {
                this.onChangeAccidentInsuranceEmployeeTemporaryPay(e.target.value);
              }}
              onBlur={e => {
                this.onChangeAccidentInsuranceEmployeeTemporaryPay(e.target.value);
              }}
            />
          </td>
          <td>{numberWithComma(this.state.totalAccidentInsuranceEmployeeCount)}</td>
          <td>{numberWithComma(this.state.totalAccidentInsuranceEmployeePay)}</td>
        </tr>
      </FormSection>
    );
  }
}
export default MonthlySummaryAccidentInsurance;
